export default "__VITE_ASSET__Df8xU2kM__"